// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nipajurddmmypgpzeugf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5pcGFqdXJkZG1teXBncHpldWdmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkxMjc1NjYsImV4cCI6MjA1NDcwMzU2Nn0.yBfPlOSr2TyT5_3IpBMikVUrrPT1l-lw-vhoJM7D1ZQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);